import React from 'react';
import { getOtherProjectLabels } from '../../../../Helpers/invoiceAutomationSetupPageHelper';

// The projects whose ready jobs go on the invoice, at the foot of its card: this project, then the others on it, as
// chips. Those who may change the setup get a button that opens the window changing them (onChange): "Combine with
// another project", or "Change" once others are on it. It is left out when no project of the client can go on it.
export default function InvoiceAutomationProjectsOnInvoice({ setup = null, canEdit = false, onChange = () => {} }) {
  const otherProjectLabels = getOtherProjectLabels(setup);
  const canChange = canEdit && (setup.ClientProjects ?? []).length > 0;
  return (
    <div className='iauto-projects'>
      <span className='lvals-label'>Projects on this invoice</span>
      <div className='iauto-projects-row'>
        <span className='chip iauto-projects-own'>This project</span>
        {otherProjectLabels.map((otherProjectLabel) => (
          <span
            key={otherProjectLabel}
            className='chip'
          >
            {otherProjectLabel}
          </span>
        ))}
        {canChange && (
          <button
            type='button'
            className='iauto-projects-change'
            onClick={onChange}
          >
            {otherProjectLabels.length > 0 ? 'Change' : 'Combine with another project'}
          </button>
        )}
      </div>
    </div>
  );
}
